//import { browser } from '$app/environment'; //this one does not work with webpack and svelte-loader. Needed for making bundles for old tlmd implementation
import { writable } from 'svelte/store';
const THEME_KEY = 'theme';
//replacement for import. Needed for making bundles for old tlmd implementation
const _browser = typeof window !== 'undefined';
export var Theme;
(function (Theme) {
    Theme["light"] = "light";
    Theme["dark"] = "dark";
})(Theme || (Theme = {}));
export const getTheme = () => Theme.dark;
// for now always dark in the beginning
// _browser && window.sessionStorage.getItem(THEME_KEY)
// 		? JSON.parse(<string>window.sessionStorage.getItem(THEME_KEY))
// 		: _browser && window.matchMedia('(prefers-color-scheme: dark)').matches
// 			? Theme.dark
// 			: Theme.light;
export const theme = writable(getTheme());
theme.subscribe((theme) => {
    if (_browser) {
        window.sessionStorage.setItem(THEME_KEY, theme ? JSON.stringify(theme) : '');
    }
});
export const setTheme = (newTheme = Theme.light) => {
    const _newTheme = newTheme ?? Theme.light;
    if (_browser && document && document.body != null) {
        if (_newTheme === Theme.dark) {
            document.body.classList.remove(Theme.light);
            document.body.classList.add(Theme.dark);
        }
        else {
            document.body.classList.remove(Theme.dark);
            document.body.classList.add(Theme.light);
        }
        theme.update((t) => _newTheme);
    }
    return _newTheme;
};
setTheme(getTheme());
